import React from 'react';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import TelemetryReportView from '../../components/Telemetry/TelemetryReportView';

const TelemetaryReport = () => (
    <>
        <MetaData title="Telemetry Report" />
        <Sidebar />
        <section className="home-section">
            <TopBar />
            <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded-card" style={{ backgroundColor: '#FAFAFA' }}>
                <div className="home-content">
                    <TelemetryReportView idPrefix="admin" />
                </div>
            </div>
        </section>
    </>
);

export default TelemetaryReport;
